import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import ErrorMessage from "../errorMessage";
import { useAppSelector } from "src/hooks/useRedux";
import { API_RESULT } from "src/utils/enums";
import Loader from "../loader/Loader";
import { useLogAnalytics } from "src/hooks/useLogAnalytics";
interface IframeProps {
  src: string;
  refresh: boolean;
}

const Iframe: React.FC<IframeProps> = ({ src, refresh }) => {
  useLogAnalytics({ activate_credit_card_iframe: true });
  const [loaded, setLoaded] = useState(false);
  const { strings, iframeResStatus } = useAppSelector((state) => state.app);
  const [showError, setShowError] = useState(false);
  const handleLoad = () => {
    setLoaded(true);
  };



  useEffect(() => {
    if (iframeResStatus == API_RESULT.FAILED) {
      setShowError(true);
    }
  }, [iframeResStatus]);
  return (
    <div className={styles.iframe}>
      {src ? (
        <iframe
          key={refresh ? "refresh" : "normal"}
          src={src}
          onLoad={handleLoad}
          title="Content Frame"
          className={loaded ? styles.iframeLoaded : styles.iframeLoading}
        />
      ) : showError ? (
        <ErrorMessage message={strings.t_cg_no_iframe_url} />
      ) : (
        <Loader fullHeight={false} customClassName={styles.iframeLoader} />
      )}
    </div>
  );
};

export default Iframe;
